import { ProductCard } from "../ProductCard/ProductCard.tsx";
import * as Style from "./ProductSearchResults.styles.ts";
import { MerchandiseProductViewModelPagedItemCollection } from "../../../api/getMerchandiseProducts.ts";
import { ChangeEvent } from "react";
import { MarketingMaterialsCart } from "../../../hooks/useMarketingMaterialsCart.ts";
import { models } from "../../../../../types/api/viewModels.ts";

interface ProductSearchResultsProps {
	searchResults?: MerchandiseProductViewModelPagedItemCollection;
	cartData?: MarketingMaterialsCart;
	pageNumber: number;
	onPageChange: (pageNumber: number) => void;
	addCartItem: (item: models["MerchandiseProductViewModel"], quantity: number) => void;
}

export const ProductSearchResults = ({
	searchResults,
	cartData,
	pageNumber,
	onPageChange,
	addCartItem
}: ProductSearchResultsProps) => {
	const handleChange = (event: ChangeEvent<unknown>, value: number) => {
		onPageChange(value);
	};

	return (
		<>
			<Style.ProductSearchResultsBox>
				{(searchResults?.items ?? []).map((product, index) => (
					<ProductCard
						key={`${pageNumber}-${index}`}
						product={product}
						cartData={cartData}
						addCartItem={addCartItem}
					/>
				))}
			</Style.ProductSearchResultsBox>
			{(searchResults?.totalCount ?? 0) > 0 && (
				<Style.PaginationStack spacing={2}>
					<Style.PaginationButton
						showFirstButton
						showLastButton
						count={searchResults?.totalPages}
						shape="rounded"
						page={pageNumber}
						onChange={handleChange}
					/>
				</Style.PaginationStack>
			)}
		</>
	);
};
